module.exports = __webpack_public_path__ + "static/media/circle_filled_green.e9fbe775.svg";